import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const IdealMembersInputSmallContainer = styled.div`
  > button {
    display: none;
  }

  @media screen and (max-width: ${layout.sm}) {
    display: grid;
    grid-row-gap: 1rem;

    > button {
      display: block;
      border-radius: 30px;
    }
  }
`;

export const InputWrapper = styled.div<{ inlineButtonOnMobile: boolean }>`
  height: 60px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 1rem 0 2.5rem;
  background: ${palette.solitudeFog};
  border: 1px solid rgba(20, 25, 33, 0.1);
  border-radius: 30px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  > button {
    height: 40px;
    padding: 0px 2rem;
    border-radius: 30px;

    @media screen and (max-width: ${layout.sm}) {
      display: ${({ inlineButtonOnMobile }) => (inlineButtonOnMobile ? 'block' : 'none')};
    }
  }

  @media screen and (max-width: ${layout.sm}) {
    padding: 0 1rem;
  }
`;

export const Input = styled.input`
  text-align: left;
  background: ${palette.solitudeFog};
  font-size: 1.1em;
  width: 100%;
  height: 100%;
  border: 0;
  box-sizing: border-box;
  border-radius: 15px;

  &:focus {
    outline: none;
  }
`;

